export default {
	title: 'Modo de Cálculo del Modelo',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote',
		start: 'Iniciar',
		stop: 'Detener'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		setSuccess: 'Configuración exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		md: 'Categoría del Modelo',
		mdcode: 'Código de Categoría del Modelo',
		mversion: 'Versión',
		mm: 'Subcategoría del Modelo',
		mmcode: 'Código de Subcategoría del Modelo',
		mdesc: 'Descripción de Falla',
		mDCode: 'Categoría del Modelo',
		placeholder: {
			md: 'Por favor ingrese la categoría del modelo',
			mdcode: 'Por favor ingrese el código de categoría del modelo',
			mversion: 'Por favor ingrese la versión',
			mm: 'Por favor ingrese la subcategoría del modelo',
			mmcode: 'Por favor ingrese el código de subcategoría del modelo',
			mdesc: 'Por favor ingrese la descripción de falla',
			mDCode: 'Por favor ingrese la categoría del modelo'
		}
	},
	table: {
		md: 'Categoría del Modelo',
		mdcode: 'Código de Categoría del Modelo',
		mm: 'Subcategoría del Modelo',
		mmcode: 'Código de Subcategoría del Modelo',
		mtype: 'Tipo de Modelo',
		isEnable: 'Habilitado',
		mdesc: 'Descripción de Falla',
		mversion: 'Versión'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	gridLayout: 'Diseño de Cuadrícula'
}
